module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-panel"
  }, [_c('div', {
    attrs: {
      "id": "normalBar"
    }
  }, [_c('mt-header', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "title": _vm.isAdd ? '新增地址' : '编辑地址'
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "onClick": "history.back();"
    },
    slot: "left"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "slot": "icon",
      "src": require("../../assets/icon/back.png"),
      "height": "auto",
      "width": "8px"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.isEdite && _vm.isAdd) ? _c('span', {
    staticClass: "edite",
    on: {
      "click": _vm.addSave
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.isEdite && !_vm.isAdd) ? _c('span', {
    staticClass: "edite",
    on: {
      "click": _vm.editSave
    }
  }, [_vm._v("保存")]) : _vm._e()])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#d8d8d8"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-edit-sec"
  }, [_c('ul', {
    staticClass: "edit-list"
  }, [_c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdite,
      "placeholder": "收货人",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "readonly": !_vm.isEdite,
      "placeholder": "收货人手机"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area),
      expression: "area"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": "readonly",
      "placeholder": "收货城市"
    },
    domProps: {
      "value": (_vm.area)
    },
    on: {
      "click": function($event) {
        _vm.isEdite ? _vm.popupVisible = true : ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.area = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdite,
      "placeholder": "详细地址，如街道、楼层、门牌号等"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "address-popup",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('addressPick', {
    attrs: {
      "isOrderAddress": _vm.isOrderAddress
    },
    on: {
      "cancel": _vm.togglePopup,
      "submit": _vm.setAddressArea
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0295907f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/addressEdit.vue
// module id = 543
// module chunks = 1